import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import OpenNotations from '../../../../assets/images/stem-notation-icon';
import SvgIconButton from '../../../../components/SvgIconButton';
import {white} from '../../../../themes/colors';
import '../../create.scss';


const iconStyle = {
    fontSize: 32,
    width: '1em',
    height: '1em',
    fill: white
};

const buttonStyle = {
    height: '32px',
    minHeight: '32px',
    width: '32px',
    minWidth: '32px',
    borderRadius: 0,
    margin: 0
};

@inject('projectStore', 'notationViewerStore')
@observer
class StudioLooperTrackNotation extends Component {


    onNotationClick = () => {
        const {notation, notationViewerStore} = this.props;
        notationViewerStore.setNotation(notation);
        this.props.onNotationClick();
        this.props.projectStore.openFilePreview(this.props.notation.file)();
    };

    render() {
        const {notation} = this.props;
        return (
            <div className="track-notation-wrapper">
                <SvgIconButton
                    className="track-notation-button" icon={OpenNotations} viewBox="0 0 36 36" iconStyle={iconStyle}
                    style={{...buttonStyle}} rippleColor={`rgba(${white} , .0)`} hoverColor={`rgba(${white} , .0)`} containerClass="center-btn" onClick={this.onNotationClick}>
                </SvgIconButton>
                <div className="track-notation-title" onClick={this.onNotationClick}>{notation.name}</div>
            </div>
        )
    }
}

StudioLooperTrackNotation.propTypes = {
    notation: PropTypes.object.isRequired,
    onNotationClick: PropTypes.func,

};

export default StudioLooperTrackNotation;
